import { render } from "./userbar.vue?vue&type=template&id=a0053010&scoped=true"
import script from "./userbar.vue?vue&type=script&lang=js"
export * from "./userbar.vue?vue&type=script&lang=js"

import "./userbar.vue?vue&type=style&index=0&id=a0053010&scoped=true&lang=css"

import exportComponent from "E:\\newwww\\shared_space\\shared_store\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0053010"]])

export default __exports__